import React from "react";
import styled from "styled-components";

const VERSION = "1.00";

const Version = () => {
  return <VersionSC>v{VERSION}</VersionSC>;
};

const VersionSC = styled.small`
  display: block;
  text-align: right;
  font-size: 12px;
  opacity: 0.5;
  margin-top: 8px;
`;

export default Version;
